export default __webpack_public_path__ + "static/cd-mwb-920ae5a3e3d4054dd6ee6c19f51147cd.jpg";